import { gql } from "@apollo/client";

export function categoriesConfig({ intl }) {
  return [
    {
      value: "cut",
      label: intl.formatMessage({
        defaultMessage: "Cut",
      }),
    },
    {
      value: "color",
      label: intl.formatMessage({
        defaultMessage: "Color",
      }),
    },
    {
      value: "styling",
      label: intl.formatMessage({
        defaultMessage: "Styling",
      }),
    },
  ];
}

export const sortConfig = [
  { label: "Soonest to Latest", value: "date-asc", key: "data.dateTime", dir: "1" },
  { label: "Latest to Soonest", value: "date-desc", key: "data.dateTime", dir: "-1" },
  { label: "Sort Name Asc", value: "name-asc", key: "n", dir: "1" },
  { label: "Sort Name Desc", value: "name-desc", key: "n", dir: "-1" },
  { label: "Points Low to High", value: "points-asc", key: "ecommerce.price.amount", dir: "1" },
  { label: "Points High to Low", value: "points-desc", key: "ecommerce.price.amount", dir: "-1" },
];

// Placeholder for tags query (can be updated later with actual GraphQL)
export const GET_ACADEMY_TAGS = gql`
  query GetAcademyTags {
    tags {
      _id
      name
    }
  }
`;

export const academyTagPath = "tags";

export const GET_EDUCATION_REWARDS = gql`
  query GetEducationRewards(
    $sort: [SortInput]
    $page: Int
    $filters: String
    $limit: Int
    $locale: String
  ) {
    content {
      findClubH(
        sort: $sort
        page: $page
        filters: $filters
        limit: $limit
        locale: $locale
      ) {
        docs {
          ... on EducationReward {
            _id
            n
            sl
            type
            brand {
              _id
              n
            }
            gallery {
              media {
                _id
              }
            }
            data {
              category
              distributor
              locationName
              province
              city
              dateTime
              inventoryLimit
              redemptionLimit
              bookingLink
              subCategory
            }
            ecommerce {
              price {
                amount
                currency
              }
              fullPrice {
                amount
                currency
              }
            }
          }
        }
        page
        pages
        limit
        total
      }
    }
  }
`;
